import {
  GET_LIST_OF_PARKS_FAILURE,
  GET_LIST_OF_PARKS_SUCCESS,
  FETCH_LIST_OF_PARKS,
} from "../constant";
import { X_API_KEY } from "../../Constants";
import { API } from 'aws-amplify'

const getListOfParksSuccess = (parks) => {
  return {
    type: GET_LIST_OF_PARKS_SUCCESS,
    payload: {
      success: parks.success,
      parks: parks.message.rows,
    },
  };
};

const getListOfParksFailure = (error) => {
  return {
    type: GET_LIST_OF_PARKS_FAILURE,
    payload: { error },
  };
};

export const fetchListOfParks = () => {
  return {
    type: FETCH_LIST_OF_PARKS,
  };
};

export const getListOfParks = () => {
  return (dispatch) => {
    dispatch(fetchListOfParks());
    API.get('UserQueries', "/api/v1/getallparks", {
      headers: {
        "X-API-KEY": X_API_KEY,
      },
    })
      .then((res) => {
        dispatch(getListOfParksSuccess(res));
      })
      .catch((err) => {
        dispatch(
          getListOfParksFailure(
            err?.response?.data?.message
              ? err?.response?.data?.message
              : err.message
          )
        );
      });
  };
};
